export default __webpack_public_path__ + "static/media/ads.44b888dc.png";